import type * as BitmovinAnalyticsBitmovinBundle from '@foundation-player/plugin-bitmovin-analytics-bitmovin';
import type * as BitmovinAnalyticsDashjsBundle from '@foundation-player/plugin-bitmovin-analytics-dashjs';
import { PlayerType, PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createBitmovinAnalyticsPlugin: PluginFactoryFunction = (builderConfig) => {
  let bitmovinAnalytics: PackageName.PluginBitmovinAnalyticsBitmovin | PackageName.PluginBitmovinAnalyticsDashjs;

  switch (builderConfig.playerType) {
    case PlayerType.Bitmovin:
      bitmovinAnalytics = PackageName.PluginBitmovinAnalyticsBitmovin;
      break;
    case PlayerType.DashJs:
      bitmovinAnalytics = PackageName.PluginBitmovinAnalyticsDashjs;
      break;
    default:
      console.error(`Cannot enable Bitmovin analytics for player type "${builderConfig.playerType}"`);
      return undefined;
  }

  return [
    [bitmovinAnalytics],
    () => {
      const bitmovinAnalyticsGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[bitmovinAnalytics];

      if (builderConfig.playerType === PlayerType.Bitmovin) {
        return [
          new (resolveByPackageNameOrThrow<typeof BitmovinAnalyticsBitmovinBundle>(bitmovinAnalytics).BitmovinPlugin)(
            builderConfig.pluginConfigs[bitmovinAnalyticsGlobalName] as BitmovinAnalyticsBitmovinBundle.PluginConfig,
          ),
        ];
      } else {
        return [
          new (resolveByPackageNameOrThrow<typeof BitmovinAnalyticsDashjsBundle>(bitmovinAnalytics).DashJsPlugin)(
            builderConfig.pluginConfigs[bitmovinAnalyticsGlobalName] as BitmovinAnalyticsDashjsBundle.PluginConfig,
          ),
        ];
      }
    },
  ];
};
